<div  role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Court</h2>
      </div>
      <div class="modal-body">
        <form #courtForm="ngForm">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                        <label for="courtName">Court Name</label>
                        <input class="form-control" name="courtName" id="courtName"  placeholder="Court Name" [(ngModel)]="court.courtName" required>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="form-group">
                        <label for="address">Address</label>
                        <input class="form-control" name="address" id="address"  placeholder="Address" [(ngModel)]="court.address" required>
                      </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                        <label for="postcode">Postcode</label>
                        <input class="form-control" name="postcode" id="postcode"  placeholder="Postcode" [(ngModel)]="court.postcode" required>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                        <label for="title">Email</label>
                        <input class="form-control" name="email" id="email"  placeholder="Email" [(ngModel)]="court.email" required>
                      </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                        <label for="title">Telephone</label>
                        <input class="form-control" name="telephone" id="telephone"  placeholder="Telephone" [(ngModel)]="court.telephone" required>
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                      <label for="fax">fax</label>
                      <input class="form-control" name="fax" id="fax"  placeholder="Fax" [(ngModel)]="court.fax" required>
                    </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="active">Set To Archieved</label>
                    <select name="active" id="active" class="form-control" [(ngModel)]="court.active" required>
                        <option value="0">Yes</option>
                        <option value="1">No</option>
                    </select>
                </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <label for="note">Note</label>
                    <textarea name="note" id="note" class="form-control" [(ngModel)]="court.note" rows="4"></textarea>
                </div>
            </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-success" (click)="saveCourtData(courtForm.value)" [disabled]="courtForm.invalid">Save Court</button>
          <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>